import React, { useEffect, useState } from "react";
import classNames from "classnames";
import { withStyles } from "@material-ui/core/styles";
import { Avatar, ListItem, ListItemText } from "@material-ui/core";
import "./ConversationItem.scss";
import Image from "@material-ui/icons/Image";
import Video from "@material-ui/icons/Videocam";
import Doc from "@material-ui/icons/InsertDriveFile";
import { maxTextLength, formatedMentions } from "../../../utils/formatters";
import app from "../../../services/base";
import moment from "moment";
import "moment/locale/pt-br";
moment.locale("pt-br");

const styles = () => ({
  colorDefault: {
    backgroundColor: "#51A6FF",
  },
  divider: {
    paddingBottom: 2,
  },
  primary: {
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: 14,
    color: "#303030",
    fontFamily: "Open Sans",
  },
  secondary: {
    color: "#303030",
    fontStyle: "normal",
    fontWeight: "normal",
    fontSize: 14,
    fontFamily: "Open Sans",
  },
});
const ConversationItem = ({
  conversation,
  userId,
  isActive,
  setSelectedConversation,
  classes,
}) => {
  const [targetConversation, setTargetConversation] = useState({});
  const [countNotSeenMessages, setCountNotSeenMessages] = useState(0);
  const className = classNames(
    "conversation",
    {
      active: isActive,
    },
    classes.divider
  );
  useEffect(() => {
    try {
      if (conversation.chatType !== "GroupChat") {
        let targetUser =
          conversation.sender === userId
            ? conversation.receiverUser
            : conversation.senderUser;

        targetUser.id =
          conversation.sender === userId
            ? conversation.receiver
            : conversation.sender;

        setTargetConversation({
          title: `${targetUser.firstName} ${targetUser.lastName}`,
          photoURL: targetUser.photoURL,
          id: targetUser.id,
        });
      } else {
        setTargetConversation(conversation.groupInfo);
      }
    } catch (e) {}
  }, [conversation, userId]);

  useEffect(() => {
    const unsubscribeGetNotSeenMessages = app
      .firestore()
      .collection("connections")
      .doc(conversation.id)
      .collection("chat")
      .orderBy("createdAt", "asc")
      .onSnapshot(
        {
          includeMetadataChanges: true,
        },
        (querySnapshot) => {
          if (!querySnapshot || querySnapshot.docs.length < 1) {
            return;
          }
          let notSeenMsgs = 0;

          querySnapshot.docs.forEach((doc) => {
            if (
              !doc.data().system &&
              doc.data().userSeen &&
              doc.data().users &&
              doc.data().users.includes(userId) 
            ) {
              if (
                !doc.data().userSeen ||
                !doc.data().userSeen.includes(userId)
              ) {
                notSeenMsgs++;
              }
            }
          });
          setCountNotSeenMessages(notSeenMsgs);
        }
      );
    return () => {
      unsubscribeGetNotSeenMessages();
    };
  }, [conversation.id, userId]);

  function renderAttachment(attachment) {
    if (attachment.type.includes("image")) {
      return (
        <div style={{ display: "flex", alignItems: "center" }}>
          <Image /> <span className={classes.secondary}> Imagem</span>{" "}
        </div>
      );
    } else if (attachment.type.includes("video")) {
      return (
        <div style={{ display: "flex", alignItems: "center" }}>
          <Video /> <span className={classes.secondary}> Vídeo</span>{" "}
        </div>
      );
    } else {
      return (
        <div style={{ display: "flex", alignItems: "center" }}>
          <Doc /> <span className={classes.secondary}> Documento</span>{" "}
        </div>
      );
    }
  }

  function getDiffDate() {
    const dateChat =
      conversation.lastMessage &&
      conversation.lastMessage.createdAt &&
      conversation.lastMessage.createdAt.toDate();
    if (!dateChat) {
      return "";
    }
    if (moment().isSame(conversation.lastMessage.createdAt.toDate(), "day")) {
      return moment(conversation.lastMessage.createdAt.toDate()).format(
        "HH:mm"
      );
    } else if (
      moment()
        .subtract(1, "days")
        .isSame(conversation.lastMessage.createdAt.toDate(), "day")
    ) {
      return "ontem";
    } else {
      return moment(conversation.lastMessage.createdAt.toDate()).format(
        "DD/MM/YY"
      );
    }
  }
  function renderMessageDelete() {
    return (
      <div style={{ display: "flex", alignItems: "center" }}>
        <span
          style={{
            fontFamily: "Open Sans",
            color: "#2A3841",
            fontSize: 12,
            fontStyle: "italic",
          }}
        >
          mensagem apagada
        </span>
      </div>
    );
  }

  return (
    <ListItem
      className={className}
      onClick={() => setSelectedConversation(conversation)}
    >
      <Avatar
        className={classes.colorDefault}
        src={targetConversation.photoURL}
      />
      <ListItemText
        classes={{
          primary: classes.primary,
          secondary: classes.secondary,
        }}
        primary={targetConversation.title}
        secondary={
          conversation.lastMessage &&
          conversation.lastMessage.system &&
          conversation.lastMessage.tag === "delete"
            ? renderMessageDelete()
            : conversation.lastMessage && conversation.lastMessage.attachment
            ? renderAttachment(conversation.lastMessage.attachment)
            : conversation.lastMessage && conversation.lastMessage.text != null
            ? conversation.lastMessage.text.length >= 20
              ? maxTextLength(
                  formatedMentions(conversation.lastMessage.text, userId),
                  20
                )
              : formatedMentions(
                  conversation.lastMessage.text
                    .trim()
                    .replace(/(\r\n|\n|\r)/gm, " "),
                  userId
                )
            : "Enviar uma mensagem."
        }
      />
      {/* Data, quantidade de mensagens não lidas */}
      <div className="right-listItem">
        <div id="last-message-date">{getDiffDate()}</div>
        {countNotSeenMessages > 0 && (
          <div class="notification">
            <span class="badge">{countNotSeenMessages}</span>
          </div>
        )}
      </div>
    </ListItem>
  );
};

export default withStyles(styles)(ConversationItem);
